export const sessionStorageKeys = {
  orderSearchCriteria: 'orderSearchCriteria'
};



// WEBPACK FOOTER //
// ./src/common/constants/sessionStorageKeys.js